/* eslint-disable @typescript-eslint/no-floating-promises */
import { changePassword } from '@app/services/authService';
import { getProfile, updateProfile } from '@app/services/userService';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useAuth } from './useAuth';

interface Options {
  onUpdateSuccess?: () => void;
  onUpdateError?: (error: Error) => void;

  onChangePasswordSuccess?: () => void;
  onChangePasswordError?: (error: Error) => void;
}
export function useProfile(options?: Options) {
  const { tokenData } = useAuth();
  const token = tokenData?.token || '';

  const { data, isLoading, isError } = useQuery(
    'profile',
    () => getProfile(token),
    { retry: 2 },
  );
  const queryClient = useQueryClient();

  const chnagePasswordMutation = useMutation(changePassword, {
    onSuccess: () => {
      if (options?.onChangePasswordSuccess) options.onChangePasswordSuccess();
    },
    onError: (error: Error) => {
      if (options?.onChangePasswordError) options.onChangePasswordError(error);
    },
  });

  const onChangePassword = (values: {
    oldPassword: string;
    newPassword: string;
  }) => {
    chnagePasswordMutation.mutate({ token, ...values });
  };

  const updateMutation = useMutation(updateProfile, {
    onSuccess: () => {
      queryClient.invalidateQueries('profile');
      if (options?.onUpdateSuccess) options.onUpdateSuccess();
    },
    onError: (error: Error) => {
      if (options?.onUpdateError) options.onUpdateError(error);
    },
  });

  const onUpdate = (values: {
    profilePicture?: File;
    firstName?: string;
    lastName?: string;
  }) => {
    updateMutation.mutate({ token, ...values });
  };

  return {
    data,
    isLoading,
    token,
    changePassword: onChangePassword,
    changePasswordIsLoading: chnagePasswordMutation.isLoading,
    updateProfile: onUpdate,
    updateProfileIsLoading: updateMutation.isLoading,
    isError,
  };
}
